<template>
  <vs-prompt
    :title="'Add section for ' +  (venueSetup ? venueSetup.name : '')"
    @cancel="val = ''"
    @accept="onAccept"
    :active.sync="addNewCampaignPrompt"
    :accept-text="'Add section'"
    :is-valid="validForm"
    class="edit-venue-popup">
    <div>
        <h6 class="mt-0">Name of the section</h6>
        <p class="mb-1"><small>Give it a name</small></p>
        <vs-input class="inputx" placeholder="Section name" v-model="sectionName"/>
    </div>
  </vs-prompt>
</template>

<script>
import { mapGetters } from "vuex";
import flatPickr from "vue-flatpickr-component";
import { ACTIONS as VENUE_ACTIONS} from "@/store/modules/marcom/marcom";

export default {
  components: { },
  data() {
    const that = this;
    return {
      venueSetup: null,
      sectionName:'',
      addNewCampaignPrompt: false,
      callback:null,
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
      isLoadingLocations: "marcom/isLoadingLocations"
    }),
    validForm() {
      return  this.sectionName !== '';
    }
  },
  methods: {
    show(venueSetup) {
      this.venueSetup = venueSetup;
      this.addNewCampaignPrompt = true;
    },
    async onAccept() {
      this.$vs.loading();

      //Call service
      var sectionCommand = {
        venueSetupId: this.venueSetup.id,
        sectionName: this.sectionName,
        isActive: true,
      }

      var result = await this.$store.dispatch('marcom/' + VENUE_ACTIONS.AddSection, sectionCommand);

      this.$vs.notify({
        color: "success",
        title: "Section added",
        text: "Your section was added",
      });
      this.$emit("section-added", this.resultMove);

      this.sectionName = '';

      this.$vs.loading.close();

      return result;
    },
  },
};
</script>

<style lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.edit-venue-popup.con-vs-dialog .vs-dialog {
  max-width: 1080px !important;
  position: relative;

  .vs-dialog-text {
    padding: 2rem !important;
  }

  .dialog-title {
    padding: 2rem;
  }
}

.vs-dialog {
  position: relative;

  overflow-y: auto;
  overflow-x: clip;
  max-height: 100%;
}

.button-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}
.con-vs-dialog .vs-dialog {
  max-width: 600px;
}
.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}

.color-select {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  li {
    position: relative;
    width: 20px;
    height: 20px;
    margin: 10px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    $colors: (
      #cccccc,
      #cea8bc,
      #a9c3c8,
      #bcd611,
      #de9c9b,
      #fbe6a2,
      #aac1f0,
      #b2a7d2,
      #bc4b31,
      #111111
    );
    @for $i from 1 through length($colors) {
      &:nth-child(#{$i}) {
        background-color: nth($colors, $i);
        box-shadow: 0px 8px 12px -6px lighten(nth($colors, $i), 0.9);
      }
    }

    .selected {
      position: absolute;
      display: block;
      border-radius: 50%;
      border: 3px solid black;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
